import { useAppContext } from '../../providers';
import { useAppDispatch } from '../../providers/AppProvider/AppProvider';
import * as types from '../../providers/AppProvider/types';

/**
 * Hook for getting / setting the selected location with persistence
 * @returns {{selectedLocation: string, setSelectedLocation: (payload: string) => void}}
 */
export const useSelectedLocation = () => {
  const dispatch = useAppDispatch();
  const { selectedLocation } = useAppContext();

  /**
   * Set the selected location and persist it
   * @param {string} payload - The location identifier to select
   */
  const setSelectedLocation = (payload) => {
    dispatch({ type: types.SELECTED_LOCATION, payload });
    localStorage.setItem(types.SELECTED_LOCATION, payload);
  };

  return {
    selectedLocation,
    setSelectedLocation,
  };
};
